module.exports = __webpack_public_path__ + "static/media/scr2.80c1e9fd.png";